
    <template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 19">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M14.9916 19H15.0194C15.808 19 16.4017 18.6302 16.6893 17.9554L16.7983 17.7058L16.8058 17.6885C17.0562 17.1115 17.3147 16.516 17.4708 15.873C17.9764 13.7907 18.5052 11.5558 18.9366 9.33937C19.0781 8.61829 18.983 8.07286 18.649 7.66841C18.1898 7.11373 17.4453 7.04902 16.9258 7.04902H13.9108C13.6139 7.04902 13.3959 6.78093 13.4493 6.49203V6.48741C13.6812 5.25094 13.8923 3.80878 13.4794 2.32271C13.222 1.38669 12.7558 0.730325 12.0577 0.312006C11.7099 0.106313 11.355 0 11.0002 0C10.0957 0 9.41844 0.677168 9.31175 1.71719C9.25841 2.23951 9.20739 2.7341 9.07519 3.18246C8.59743 4.79102 7.45636 5.98358 6.40575 6.9404C6.13439 7.18307 5.81666 7.6453 5.81434 8.13757C5.7981 9.94721 5.7981 11.7592 5.7981 13.5688L5.79578 16.8368C5.79347 17.7081 6.23412 18.3783 7.00643 18.6787C7.461 18.8636 7.9434 18.9653 8.43276 18.9792C9.31625 18.9908 10.1974 18.9908 11.0786 18.9908H11.079H12.3987C13.2637 18.9908 14.1288 18.9908 14.9916 19ZM1.81365 18.7828H2.08964C3.08923 18.7828 3.9056 17.9692 3.90328 16.9731V8.92106C3.90328 7.92726 3.08691 7.11373 2.08964 7.11373H1.81365C0.816373 7.11373 0 7.92726 0 8.92106V16.9754C0 17.9692 0.816373 18.7828 1.81365 18.7828Z"
    fill="currentColor"
  ></path>
</svg>

    </template>

    <script lang="ts">
    import type { DefineComponent } from 'vue'
    export default ({
      name: 'Good',
    }) as DefineComponent
    </script>
    